// Order/Containers Booking API
import queryString from 'query-string'
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    OrderModificationReason,
} from 'app/enums/label.enums'

type ContainersBookingRequests = {
    getAvailableContainersCount: RequestConfigFunction<{
        orderNumber: string,
        fieldName: string,
    }>,
    getRequiredContainersChanges: RequestConfigFunction<{
        orderNumber: string,
    }>,
    updateRequiredContainersCustomer: RequestConfigFunction<{
        orderNumber: string,
        data?: Record<string, any>,
        modificationReason?: OrderModificationReason,
        version: number,
    }>,
    updateRequiredContainersInternal: RequestConfigFunction<{
        orderNumber: string,
        data?: Record<string, any>,
    }>,
    batchUnrejectSelectedContainers: RequestConfigFunction<{
        orderNumber: string,
        data?: Record<string, any>,
    }>,
    updateGeneralFreights: RequestConfigFunction<{
        orderNumber: string,
        data?: Record<string, any>,
    }>,
    addSelectedContainers: RequestConfigFunction<{
        orderNumber: string,
        data?: Record<string, any>,
    }>,
    getAvailableContainers: RequestConfigFunction<{
        orderNumber: string,
        data?: Record<string, any>,
    }>,
    batchRejectSelectedContainers: RequestConfigFunction<{
        orderNumber: string,
        data: Record<string, any>,
    }>,
}

const containersBookingRequests: ContainersBookingRequests = {
    getAvailableContainersCount: ({
        orderNumber,
        fieldName,
    }) => {
        return {
            url: `order/${orderNumber}/available-containers/count/${fieldName}`,
            method: 'POST',
        }
    },
    getRequiredContainersChanges: ({
        orderNumber,
    }) => {
        return {
            url: `order/${orderNumber}/requiredcontainerschanges/all`,
            method: 'GET',
        }
    },
    updateRequiredContainersCustomer: ({
        modificationReason,
        orderNumber,
        version,
        data,
    }) => {
        return {
            url: queryString.stringifyUrl({
                url: `order/${orderNumber}/required-containers-customer`,
                query: modificationReason && {
                    modificationType: modificationReason,
                },
            }),
            data: {
                ...data,
                version,
            },
            method: 'PATCH',
        }
    },
    updateRequiredContainersInternal: ({
        orderNumber,
        data,
    }) => {
        return {
            url: `order/${orderNumber}/required-containers-internal?modificationType=INTERNAL`,
            method: 'PATCH',
            data,
        }
    },
    batchUnrejectSelectedContainers: ({
        orderNumber,
        data,
    }) => {
        return {
            url: `order/${orderNumber}/selected-container/batch-unrejections`,
            method: 'PATCH',
            data,
        }
    },
    updateGeneralFreights: ({
        orderNumber,
        data,
    }) => {
        return {
            url: `order/${orderNumber}/general-freights?modificationType=INTERNAL`,
            method: 'PUT',
            data,
        }
    },
    addSelectedContainers: ({
        orderNumber,
        data = {},
    }) => {
        return {
            url: `order/${orderNumber}/selected-containers`,
            method: 'POST',
            data,
        }
    },
    getAvailableContainers: ({
        orderNumber,
        data,
    }) => {
        return {
            url: `order/${orderNumber}/available-containers`,
            method: 'POST',
            data,
        }
    },
    batchRejectSelectedContainers: ({
        orderNumber,
        data,
    }) => {
        return {
            url: `order/${orderNumber}/selected-container/batch-rejections`,
            method: 'PATCH',
            data,
        }
    },
}

export default containersBookingRequests
